import React, { useEffect } from 'react'
import { useState } from "react";
import logo from "../assets/WithShapes2.webp";
import '../css/siteColorsCSS.css';
import '../css/NavbarStyle.css';
import { setLanguage } from '../lang';
import LanguageSwitcher from './LanguageSwitcher';
import LanguageSwitcher2 from './LanguageSwitcher2';


const NavBar = () => {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) return savedLang;
    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.startsWith("sl") ? "sl" : "en";
  });

  useEffect(() => {
    setLanguage(lang);
    localStorage.setItem("lang", lang);
  }, [lang]);


  // const [lang, setLang] = useState("en"); // default language

  // const toggleLanguage = () => {
  //   const newLang = lang === "en" ? "sl" : "en";
  //   setLang(newLang);
  //   setLanguage(newLang); // your JS translator
  // };



  return (
    <nav>
      <a className="brand" href="#home">
        <img className="logoContainer" src={logo} alt="logo" />
        <span className="company-name">Igralis</span>
      </a>

      <div className="nav-links">
        <a data-translate="navLink1" className='navLink' href="#home">Home</a>
        <a data-translate="navLink2" className='navLink' href="#about">About us</a>
        <a data-translate="navLink3" className='navLink' href="#services">Services</a>
        <a data-translate="navLink4" className='navLink' href="#contact">Contact</a>
        {/* <button className='langButton' onClick={toggleLanguage}>{lang === "en" ? "🇬🇧" : "🇸🇮"}</button> */}
        {/* <div class="lang-switcher">
                    <button id="lang-en" class="active" onclick="setLanguage('en')">EN</button>
                    <button id="lang-sl" onclick="setLanguage('sl')">SL</button>
                </div> */}
        <LanguageSwitcher lang={lang} setLang={setLang} />

      </div>

      <div className="hamburger">
        <button className='hamburgerButton' onClick={() => setOpen(true)}>☰</button>
        {/* <LanguageSwitcher lang={lang} setLang={setLang}/> */}
        <LanguageSwitcher2 lang={lang} setLang={setLang} />
      </div>

      <div className={`side-menu ${open ? "open" : ""}`}>
        <button className='navLinkMobileExitButton' onClick={() => setOpen(false)}>✕</button>
        <br/> <br/> <br/> <br/>
        <a className='navLinkMobile' href="#home" onClick={() => setOpen(false)}><p data-translate="navLink1">Home</p></a>
        <a className='navLinkMobile' href="#about" onClick={() => setOpen(false)}><p data-translate="navLink2">About us</p></a>
        <a className='navLinkMobile' href="#services" onClick={() => setOpen(false)}><p data-translate="navLink3">Services</p></a>
        <a className='navLinkMobile' href="#contact" onClick={() => setOpen(false)}><p data-translate="navLink4">Contact</p></a>
      </div>
    </nav>
  )
}

export default NavBar